import styled from '@emotion/styled';
import { CircularProgress } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Length = string | number;

interface Props {
  width?: Length;
  height?: Length;
  className?: string;
}

type StyledComponentProps = {
  width: Length;
  height: Length;
};

const Spinner = ({ width = '100%', height = 80, className }: ClassAttributes<HTMLElement> & Props) => (
  <Root width={width} height={height} className={className}>
    <div>
      <CircularProgress size={48} />
    </div>
  </Root>
);

const Root = styled('div')<StyledComponentProps>(({ width, height }) => ({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  width,
  height,
}));

export default Spinner;
